app.mediator.registerModule(MODULE_NAME__HEADINGS_AREA, function(app) {
    var helpers = app.helpers.funcs;
    return {

        $rootElem: null,

	    //==========================================================xdiv2====
	    // Start and stop
	    //===================================================================

        onLoaded: function (data) {
            var scope = this;
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                scope.init();
            }
        },

        init: function () {

	        // Init
	        var scope = this;
            scope.$rootElem = $('.area-headings');
            if (!scope.$rootElem.length) return;

            scope.addDomListeners();
            scope.addMediatorListeners();
        },

	    //==========================================================xdiv2====
	    // Event listeners
	    //===================================================================

        addDomListeners: function () {
            var $playVideoTrigger = this.$rootElem.find('.play-video-trigger');
            if ($playVideoTrigger.length) {
                $playVideoTrigger.click(function (e) {
                    e.preventDefault();
                    app.mediator.notify(EVENT_NAME__HEADINGS_AREA__VIDEO_PLAY_BUTTON_ACTIVATED);
                });
            }
        },

        addMediatorListeners: function () {
            var scope = this;
            app.mediator.addListener(EVENT_NAME__VIDEO_LIGHTBOX__CLOSED, function () {
                scope.$rootElem.find('.play-video-trigger').focus();
            });
        }
	};
});
